import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yrxpwck9xx: FaireBrandEntity = {
  token: "b_yrxpwck9xx",
  type: "brand",
  name: "The Only Bra",
  avatarUrl:
    "https://cdn.faire.com/fastly/575a63de6ee86e55d0bab4679cfffe490ff65944c80657f61021c684261e3674.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2c969ceeb633d3a10cfe1ed0cd411440bc177d3c52e511d8588e2ef8fa8cd250.png",
  logoUrl:
    "https://cdn.faire.com/fastly/575a63de6ee86e55d0bab4679cfffe490ff65944c80657f61021c684261e3674.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2c969ceeb633d3a10cfe1ed0cd411440bc177d3c52e511d8588e2ef8fa8cd250.png",
  location: "Westport, CT, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "Time and time again, women have been forced to compromise on comfort, reliability, and self-confidence when choosing between the many variations of modern bras.\n\nMost bras are so uncomfortable that women cannot wait to take them off in the evening.\n\nThis is why Joanie and Maurice Reznik set out to provide women with a luxuriously comfortable bra that they would want to wear around the clock.\n\nLike most women, Joanie has spent her entire life facing the reality that most bras are not made for the comfort of women. Maurice has more than 30 years in the category, as President and CEO of some of the leading brands in the industry. Together they decided it was time to offer women a unique soft bra that adapts to their unique shape to provide the perfect fit. That goal led to the creation of the Only Bra.\n\nBut providing women with a comfortable bra wasn’t the end of their mission.\n\nJoanie and Maurice wanted to create a bra that not only made a difference in the lives of the women who wore them but made a difference in the lives of women suffering across the nation.\n\n25% of every purchase goes to support the non-profit Shatterproof, a non-profit dedicated towards ending the addiction crisis in Americ",
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:18:15.829Z",
    importedBy: "entity-db-cli",
  },
};
